<template>
  <div id="jack-filter-questions">

    <div v-for="question in questions_to_show" class="mt-4">
      <Question :question="question" @select="selectOption" @open="openQuestion"/>
    </div>

    <div v-if="!isSomeQuestionOpen && link_to_redirect"
         class="mt-4 w-full text-dark-blue bg-light-blue py-6 px-6 text-center rounded-xl text-center">
      <a :href="link_to_redirect" class="inline-block font-bold no-underline bg-dark-blue text-white hover:bg-orange p-4 rounded-md">{{ __('START NOW') }} >> </a>
      <div class="jack-custom-link text-xs pt-4">{{ link_to_redirect }}</div>
    </div>

    <div v-if="!isSomeQuestionOpen && custom_message" class="mt-4 w-full text-dark-blue bg-light-blue py-4 px-6 text-center rounded-xl">
      <div v-html="custom_message"></div>
    </div>

  </div>
</template>

<script>
import Question from "./components/Question";
import Translate from "../../shared/mixin/Translate";
import {object} from "../../../../../../wp-includes/js/dist/redux-routine";
export default {
  mixins:[Translate],
  components: {Question},

  data(){
    return {
      questions: [],
      questions_to_show: [],

      link_to_redirect: null,
      custom_message: null
    }
  },

  computed: {
    isSomeQuestionOpen(){
      let isOpen = false
      for (let i = 0; i < this.questions_to_show.length; i++){
        if (this.questions_to_show[i].open) {
          isOpen = true
        }
      }
      return isOpen
    }
  },

  created(){
    let questions = JACKF.questions

    for (let i = 0; i < questions.length; i++){
      questions[i].open = true
      questions[i].option_selected = null
    }

    this.questions = questions
    this.recalculateQuestionsToShow()
  },

  methods: {
    recalculateQuestionsToShow(){
      //console.log('Recalculate questions')

      this.questions_to_show = []
      this.link_to_redirect = null
      this.custom_message = null

      this.questions_to_show.push(this.questions[0])
      this.addNextQuestion(this.questions[0])
    },

    addNextQuestion(question){
      if (question.option_selected == null) return

      let type = question.option_selected.action.type
      let value = question.option_selected.action.value

      if (type == 'question') {

        // Find the question with id = value
        let new_question = null
        for (let i = 0; i < this.questions.length; i++){
          if (this.questions[i].id == value) {
            new_question = this.questions[i]
          }
        }

        if (new_question) {
          this.questions_to_show.push(new_question)
          this.addNextQuestion(new_question)
        }
      }

      else if (type == 'custom_link') {
        this.link_to_redirect = value
        //alert('CUSTOM LINK ' + value)
      }

      else if (type == 'custom_link_with_params') {
        this.link_to_redirect = encodeURI( value+'?' + this.calculateParams() )
        //alert('CUSTOM LINK WITH PARAMS ' + value)
      }

      else if (type == 'custom_message') {
        this.custom_message = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }
    },

    calculateParams() {
      let params = {}
      for (let i = 0; i < this.questions_to_show.length; i++){
        params[this.questions_to_show[i].slug] = this.questions_to_show[i].option_selected.value
      }

      //console.log(params)

      let strings = []
      Object.keys(params).forEach( key => {
        strings.push (key+'='+params[key])
      })
      return strings.join('&')
    },

    selectOption(question, option) {
      question.option_selected = option
      question.open = false
      this.recalculateQuestionsToShow()
    },

    openQuestion(question) {
      for (let i = 0; i < this.questions.length; i++){
        this.questions[i].open = false
      }
      question.open = true
    }
  }
}
</script>
